import React from 'react';
import { ComposableMap, ZoomableGroup, Geographies, Geography } from 'react-simple-maps';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import countries from '../../../assets/worldMapChartConfig.json';
import colors from '../../colors';

const WorldMapChart = ({
  activeCountries,
  width,
  height,
  isResponsive,
  countryColor,
  countryHoverColor,
  activeCountryColor,
  activeCountryHoverColor,
  onClickCountry,
  className = '',
  style = {}
}) => {
  const getCountryStyle = ({
    properties = {}
  }) => {
    const countryCode = properties.ISO_A2;

    if (activeCountries.includes(countryCode)) {
      return {
        default: {
          fill: activeCountryColor,
          stroke: colors.white
        },
        hover: {
          fill: activeCountryHoverColor
        },
        pressed: {
          fill: colors['grey-900']
        }
      };
    }

    return {
      default: {
        fill: countryColor,
        stroke: colors.white
      },
      hover: {
        fill: countryHoverColor
      },
      pressed: {
        fill: colors['grey-900']
      }
    };
  };

  const handleClick = (country, e) => {
    onClickCountry && onClickCountry(country, e);
  };

  return /*#__PURE__*/React.createElement(ComposableMap, {
    width: width,
    height: height,
    className: classnames({
      'chart__full-width': isResponsive
    }, className),
    style: style
  }, /*#__PURE__*/React.createElement(ZoomableGroup, null, /*#__PURE__*/React.createElement(Geographies, {
    geography: countries
  }, (countries, projection) => countries.map((country, index) => {
    return /*#__PURE__*/React.createElement(Geography, {
      key: `${country}-${index}`,
      geography: country,
      projection: projection,
      style: getCountryStyle(country),
      onClick: handleClick
    });
  }))));
};

WorldMapChart.defaultProps = {
  isResponsive: true,
  width: 460,
  height: 280,
  countryColor: colors['grey-700'],
  countryHoverColor: colors['grey-900'],
  activeCountryColor: colors.primary,
  activeCountryHoverColor: colors['primary-darken']
};
WorldMapChart.propTypes = {
  activeCountries: PropTypes.array.isRequired,
  onClickCountry: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  isResponsive: PropTypes.bool,
  countryColor: PropTypes.string,
  countryHoverColor: PropTypes.string,
  activeCountryColor: PropTypes.string,
  activeCountryHoverColor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default WorldMapChart;